// import { OPENING } from '@namespace/home/opening'
import { ANIMATE } from '@namespace/home/animate'
// import { VIDEO } from '@namespace/home/video'

export default function home() {
  // OPENING.init({
  //   imagesPc: [
  //     '/wp-content/themes/kshp/assets/img/home/opening01_pc.webp',
  //     '/wp-content/themes/kshp/assets/img/home/opening02_pc.webp',
  //     '/wp-content/themes/kshp/assets/img/home/opening03_pc.webp',
  //     '/wp-content/themes/kshp/assets/img/home/opening04_pc.webp',
  //     '/wp-content/themes/kshp/assets/img/home/opening05_pc.webp',
  //   ],
  //   imagesSp: [
  //     '/wp-content/themes/kshp/assets/img/home/opening01_sp.webp',
  //     '/wp-content/themes/kshp/assets/img/home/opening02_sp.webp',
  //     '/wp-content/themes/kshp/assets/img/home/opening03_sp.webp',
  //     '/wp-content/themes/kshp/assets/img/home/opening04_sp.webp',
  //     '/wp-content/themes/kshp/assets/img/home/opening05_sp.webp',
  //   ],
  //   interval: 1500,
  //   fade: 1400,
  //   fadeOut: 1200,
  //   background: '#fff',
  //   // minPcWidth: 769, // 省略OK（仕様通り）
  // })

  window.addEventListener('load', () => {
    ANIMATE.init()
    // VIDEO.init()

    const signupClose = document.querySelector('.js-signup-close')
    if (signupClose) {
      signupClose.addEventListener('click', () => {
        signupClose.closest('.c-signup').classList.add('is-hidden')
      })
    }
  })
}
